"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validateLength = (minLength, maxLength, message = 'Invalid Length') => (value) => {
    if (value.length > maxLength || value.length < minLength) {
        return message;
    }
};
exports.default = validateLength;
